import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import { MAPS_EMBED, CLINIC_ADDRESS, PHONE_TEL, PHONE, buildWhatsAppUrl } from "@/lib/site";
import { MapPin, Phone, MessageCircle } from "lucide-react";

const MapSection = ({ variant = "light" }) => {
  const { t, lang } = useLang();
  const waUrl = buildWhatsAppUrl("default", lang);
  const isDark = variant === "dark";
  return (
    <section
      data-testid="map-section"
      className={`${isDark ? "bg-ink text-cream" : "bg-cream text-ink"} py-24 md:py-32`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-10 md:gap-12 items-start">
        <div className="md:col-span-4">
          <p className={`overline ${isDark ? "text-cream/60" : "text-ink/60"}`}>
            {t.contact.address_label}
          </p>
          <h2 className="mt-4 font-serif text-4xl md:text-5xl font-light leading-[1.05] tracking-tight">
            {t.contact.title}
          </h2>
          <div className="mt-8 space-y-5">
            <div className="flex items-start gap-3">
              <MapPin size={18} strokeWidth={1.4} className="mt-1 shrink-0" />
              <p className="font-light leading-relaxed whitespace-pre-line">
                {t.contact.address}
              </p>
            </div>
            <div className={`flex flex-col gap-3 pt-5 border-t ${isDark ? "border-cream/15" : "border-ink/15"}`}>
              <a
                href={waUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="map-whatsapp-cta"
                className={`inline-flex items-center gap-2 text-sm font-light link-underline`}
              >
                <MessageCircle size={15} strokeWidth={1.4} />
                {t.contact.whatsapp}
              </a>
              <a
                href={PHONE_TEL}
                data-testid="map-call-cta"
                className="inline-flex items-center gap-2 text-sm font-light link-underline"
              >
                <Phone size={15} strokeWidth={1.4} />
                {PHONE}
              </a>
            </div>
          </div>
        </div>

        <div className="md:col-span-8">
          <div className={`aspect-[16/10] md:aspect-[16/9] bg-ink overflow-hidden border ${isDark ? "border-cream/20" : "border-ink/20"}`}>
            <iframe
              title="Mapa Iñaki Mayo Dental — Cerdanyola del Vallès"
              src={MAPS_EMBED}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="w-full h-full grayscale"
              data-testid="google-map-iframe"
            />
          </div>
          <p className={`mt-3 overline ${isDark ? "text-cream/50" : "text-ink/50"}`}>
            {CLINIC_ADDRESS}
          </p>
        </div>
      </div>
    </section>
  );
};

export default MapSection;
